import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.packingView.finishedPackingDialog.title',
    defaultMessage: 'Finished packing',
    description: 'Title of the finished packing dialog',
  },
  message: {
    id: 'pages.packingView.finishedPackingDialog.message',
    defaultMessage:
      "You're done packing the parcels. You can now keep packing or start picking other shipments.",
    description: 'Message of the finished packing dialog',
  },
  actions: {
    shipments: {
      id: 'pages.packingView.finishedPackingDialog.actions.shipments',
      defaultMessage: 'Shipments',
      description: 'Label of the shipments action in the finished packing dialog',
    },
    pack: {
      id: 'pages.packingView.finishedPackingDialog.actions.pack',
      defaultMessage: 'Pack',
      description: 'Label of the pack action in the finished packing dialog',
    },
  },
};

export default defineMessages(translations);
